import { Component } from '@angular/core';
import { GloButtonComponent } from "../../../../shared/components/glo-button/glo-button.component";
import { LandingOurBlogComponent } from '../../shared/our-blog/our-blog.component';
import { RouterLink } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'landing-business-main',
    imports: [RouterLink, GloButtonComponent, LandingOurBlogComponent],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class LandingBusinessMainComponent {
    assetUrl = environment.assetBaseUrl
}
